import { Link } from "react-router-dom";
import styles from "./TalentsCTA.module.css";

export default function TalentsCTA() {
  return (
    <section className={styles.section} id="cta">
      <div className={styles.container}>
        <div className={styles.card}>
          <h2 className={styles.h2}>
            Your next opportunity is already looking for you.
          </h2>
          <p className={styles.body}>
            Join thousands of African talents being discovered every week. Build
            your profile in minutes — no CV uploads, no gatekeepers.
          </p>
          <Link
            to="/register"
            className={`${styles.btn} ${styles.btnPrimary} ${styles.btnLg} md:mr-5`}
          >
            Sign Up Now
          </Link>
          <div className={styles.meta}>
            <span>✓ Free forever for talents</span>
            <span className={styles.sep}>•</span>
            <span>✓ 3-minute setup</span>
            <span className={styles.sep}>•</span>
            <span>✓ Premium AI-insights available</span>
          </div>
        </div>
      </div>
    </section>
  );
}
